(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ascendry-cargo-pants"] && !Shopify.designMode) return;
  try {
    
function initializeCargo(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const form=root.querySelector('.ac-form');
  const variants=JSON.parse(root.querySelector('[data-cargo-variants]').textContent);
  const cards=Array.from(root.querySelectorAll('[data-pack-card]'));
  const error=root.querySelector('.ac-error');
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify.currency.active,currencyDisplay:'code'}).format(value/100);
  function selection(){
    const pack=Number(form.querySelector('[name=cargo_pack]:checked').value);
    const size=form.querySelector('[name=cargo_size]:checked')?.value;
    const card=cards.find(c=>Number(c.dataset.packCard)===pack);
    const colors=Array.from(card.querySelectorAll('.ac-color-field')).map(field=>field.querySelector('input:checked').value);
    const variant=variants.find(v=>v.option1===pack+' Pack'&&v.option2===size&&v.option3===colors[0]);
    return {pack,size,colors,variant};
  }
  function update(){
    const selected=selection();
    cards.forEach(card=>{card.querySelector('.ac-pack-colors').hidden=Number(card.dataset.packCard)!==selected.pack;card.querySelectorAll('.ac-color-field').forEach(field=>field.querySelector('[data-color-name]').textContent=field.querySelector('input:checked').value);});
    root.querySelector('[data-size-name]').textContent=selected.size||'';
    const price=selected.variant?.price??variants.find(v=>v.option1===selected.pack+' Pack').price;
    root.querySelector('[data-cargo-total]').textContent=money(price);
    if(selected.variant)form.querySelector('[name=id]').value=selected.variant.id;
    if(selected.size)root.querySelector('[data-cargo-selection]').textContent=selected.pack+' '+(selected.pack===1?'pair':'pairs')+' · Size '+selected.size+' · '+selected.colors.join(' / ');
    error.hidden=true;
  }
  cards.forEach(card=>card.addEventListener('click',event=>{
    if(event.target.closest('input,label,button,a,select,textarea'))return;
    const radio=card.querySelector('input[name=cargo_pack]');
    if(!radio.checked)radio.click();
  }));
  form.addEventListener('change',update);
  form.addEventListener('submit',async event=>{
    event.preventDefault();event.stopImmediatePropagation();
    const selected=selection();
    if(!selected.size||!selected.variant){error.textContent='Choose your size before adding your pack.';error.hidden=false;form.querySelector('[name=cargo_size]').focus();return;}
    const button=form.querySelector('[type=submit]');
    if(button.disabled)return;
    const properties={};selected.colors.forEach((color,i)=>properties['Pair '+(i+1)]=color+' / '+selected.size);
    const drawer=document.querySelector('cart-drawer');
    const items=[{id:selected.variant.id,quantity:1,properties}];
    button.disabled=true;button.setAttribute('aria-busy','true');error.hidden=true;
    try{
      if(window.ascendryMarketCleanup)await window.ascendryMarketCleanup;
      const protection=drawer?.querySelector('cart-drawer-upsell[data-handle="shipping-protection"]');
      const protectionId=Number(protection?.dataset.id);
      if(protection?.dataset.selected==='true'&&protectionId){const cartResponse=await fetch(window.Shopify.routes.root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});if(!cartResponse.ok)throw new Error('We could not confirm your cart. Please try again.');const cart=await cartResponse.json();if(!cart.items.some(item=>Number(item.variant_id)===protectionId))items.push({id:protectionId,quantity:1});}
      const payload={items};
      if(drawer){payload.sections=drawer.getSectionsToRender().map(s=>s.id);payload.sections_url=window.location.pathname;drawer.setActiveElement(button);}
      const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
      const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||'We could not add your pack. Please try again.');
      if(drawer){drawer.classList.remove('is-empty');drawer.renderContents(result);}else window.location.assign(window.Shopify.routes.root+'cart');
    }catch(e){error.textContent=e.message;error.hidden=false;}finally{button.disabled=false;button.removeAttribute('aria-busy');}
  },true);
  const outfitTrack=root.querySelector('[data-outfit-track]');if(outfitTrack){const outfitCards=Array.from(outfitTrack.querySelectorAll('article'));const outfitButtons=Array.from(root.querySelectorAll('[data-outfit-direction]'));const outfitCounter=root.querySelector('[data-outfit-count]');const position=card=>card.getBoundingClientRect().left-outfitTrack.getBoundingClientRect().left+outfitTrack.scrollLeft;const current=()=>outfitCards.reduce((best,card,i)=>Math.abs(position(card)-outfitTrack.scrollLeft)<Math.abs(position(outfitCards[best])-outfitTrack.scrollLeft)?i:best,0);const refresh=()=>{const max=outfitTrack.scrollWidth-outfitTrack.clientWidth;outfitButtons.forEach(button=>button.disabled=Number(button.dataset.outfitDirection)<0?outfitTrack.scrollLeft<=2:outfitTrack.scrollLeft>=max-2);outfitCounter.textContent=(current()+1)+' / '+outfitCards.length;};outfitButtons.forEach(button=>button.addEventListener('click',()=>{const next=Math.max(0,Math.min(outfitCards.length-1,current()+Number(button.dataset.outfitDirection)));outfitTrack.scrollTo({left:position(outfitCards[next]),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));outfitTrack.addEventListener('scroll',refresh,{passive:true});new ResizeObserver(refresh).observe(outfitTrack);refresh();}
  const detailTrack=root.querySelector('[data-detail-track]');
  if(detailTrack){
    const detailCards=Array.from(detailTrack.querySelectorAll('article'));
    const detailButtons=Array.from(root.querySelectorAll('[data-detail-direction]'));
    const detailCount=root.querySelector('[data-detail-count]');
    const position=card=>card.getBoundingClientRect().left-detailTrack.getBoundingClientRect().left+detailTrack.scrollLeft;
    const detailIndex=()=>detailCards.reduce((best,card,i)=>Math.abs(position(card)-detailTrack.scrollLeft)<Math.abs(position(detailCards[best])-detailTrack.scrollLeft)?i:best,0);
    const updateDetails=()=>{const max=detailTrack.scrollWidth-detailTrack.clientWidth;detailButtons.forEach(button=>button.disabled=Number(button.dataset.detailDirection)<0?detailTrack.scrollLeft<=2:detailTrack.scrollLeft>=max-2);detailCount.textContent=(detailIndex()+1)+' / '+detailCards.length;};
    detailButtons.forEach(button=>button.addEventListener('click',()=>{const next=Math.max(0,Math.min(detailCards.length-1,detailIndex()+Number(button.dataset.detailDirection)));detailTrack.scrollTo({left:position(detailCards[next]),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));
    detailTrack.addEventListener('scroll',updateDetails,{passive:true});
    detailTrack.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();detailButtons.find(button=>Number(button.dataset.detailDirection)===(event.key==='ArrowLeft'?-1:1)).click();}});
    new ResizeObserver(updateDetails).observe(detailTrack);updateDetails();
  }
  const image=root.querySelector('.ac-main-image');
  const thumbs=Array.from(root.querySelectorAll('[data-cargo-photo]'));
  let photoIndex=0,gesture=null,ignoreClickUntil=0;
  function showPhoto(index){if(!thumbs.length)return;photoIndex=(index+thumbs.length)%thumbs.length;image.src=thumbs[photoIndex].dataset.cargoPhoto;image.alt=thumbs[photoIndex].dataset.cargoColor?thumbs[photoIndex].dataset.cargoColor+' Everyday Cargo Pants':thumbs[photoIndex].querySelector('img').alt;image.removeAttribute('srcset');thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===photoIndex)));root.querySelector('.ac-count').textContent=(photoIndex+1)+' / '+thumbs.length;const track=root.querySelector('.ac-thumbs');const active=thumbs[photoIndex];if(track){const left=active.getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft-(track.clientWidth-active.offsetWidth)/2;track.scrollTo({left:Math.max(0,left),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}}
  const colorPhotoNames={"Black":"gallery-01-black","Grey":"gallery-02-grey","Army Green":"gallery-03-army","Cream White":"gallery-04-detail","Khaki":"color-khaki","Dark Blue":"color-dark-blue","Beige":"color-beige"};
  Object.entries(colorPhotoNames).forEach(([color,name])=>{const thumb=thumbs.find(button=>button.dataset.cargoPhoto.includes(name));if(thumb){thumb.dataset.cargoColor=color;thumb.querySelector('img').alt=color+' Everyday Cargo Pants';}});
  function previewColor(color){const index=thumbs.findIndex(button=>button.dataset.cargoColor===color);if(index>=0)showPhoto(index);}
  form.addEventListener('change',event=>{if(event.target.name?.startsWith('cargo_color_'))previewColor(event.target.value);else if(event.target.name==='cargo_pack')previewColor(selection().colors[0]);});
  thumbs.forEach((b,i)=>b.addEventListener('click',()=>showPhoto(i)));
  root.querySelectorAll('[data-photo-direction]').forEach(b=>b.addEventListener('click',()=>showPhoto(photoIndex+Number(b.dataset.photoDirection))));
  root.querySelector('.ac-photo').addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();showPhoto(photoIndex+(event.key==='ArrowRight'?1:-1));}});
  if(image){
    image.draggable=false;
    image.addEventListener('pointerdown',e=>{if(!e.isPrimary){gesture=null;return;}if(e.pointerType==='mouse'&&e.button!==0)return;gesture={id:e.pointerId,x:e.clientX,y:e.clientY};image.setPointerCapture(e.pointerId);});
    image.addEventListener('pointerup',e=>{if(!gesture||gesture.id!==e.pointerId)return;const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;gesture=null;if(Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.2){ignoreClickUntil=Date.now()+400;showPhoto(photoIndex+(dx<0?1:-1));}});
    image.addEventListener('pointercancel',()=>gesture=null);
    const dialog=root.querySelector('.ac-lightbox');
    function enlarge(){dialog.querySelector('img').src=image.currentSrc;dialog.showModal();}
    image.addEventListener('click',()=>{if(Date.now()>=ignoreClickUntil)enlarge();});root.querySelector('.ac-zoom').addEventListener('click',enlarge);dialog.querySelector('button').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  }
  const requested=variants.find(v=>String(v.id)===new URLSearchParams(window.location.search).get('variant'));
  if(requested){form.querySelector('[name=cargo_pack][value="'+parseInt(requested.option1)+'"]').checked=true;form.querySelector('[name=cargo_size][value="'+requested.option2+'"]').checked=true;form.querySelector('[name="cargo_color_'+parseInt(requested.option1)+'_1"][value="'+requested.option3+'"]').checked=true;}
  update();
}
document.querySelectorAll('[data-cargo-root]').forEach(initializeCargo);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cargo-root]').forEach(initializeCargo));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crates"] && !Shopify.designMode) return;
  try {
    
function initCrates(root){if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('.cr-track');const stage=root.querySelector('.cr-stage');const thumbs=Array.from(root.querySelectorAll('[data-cr-photo]'));const strip=root.querySelector('.cr-thumbs');const count=root.querySelector('.cr-slide-count');let active=0;function mark(index){active=index;thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));count.textContent=(index+1)+' / '+thumbs.length;const thumb=thumbs[index];if(thumb)strip.scrollTo({left:thumb.offsetLeft-(strip.clientWidth-thumb.clientWidth)/2,behavior:'smooth'})}function go(index){const next=(index+thumbs.length)%thumbs.length;mark(next);track.scrollTo({left:next*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}thumbs.forEach((b,i)=>b.addEventListener('click',()=>go(i)));root.querySelector('.cr-prev').addEventListener('click',()=>go(active-1));root.querySelector('.cr-next').addEventListener('click',()=>go(active+1));stage.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();go(active+(event.key==='ArrowRight'?1:-1))}});let scrollTimer;track.addEventListener('scroll',()=>{clearTimeout(scrollTimer);scrollTimer=setTimeout(()=>mark(Math.max(0,Math.min(thumbs.length-1,Math.round(track.scrollLeft/track.clientWidth)))),120)});const detailTrack=root.querySelector('.cr-detail-track');const detailCards=Array.from(detailTrack.children);const detailPrev=root.querySelector('.cr-detail-prev');const detailNext=root.querySelector('.cr-detail-next');let detailActive=0;function detailMark(i){detailActive=i;root.querySelector('.cr-detail-count').textContent=(i+1)+' / '+detailCards.length;detailPrev.disabled=i===0;detailNext.disabled=i===detailCards.length-1}function detailGo(i){detailMark(Math.max(0,Math.min(detailCards.length-1,i)));detailTrack.scrollTo({left:detailCards[detailActive].offsetLeft-detailCards[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}detailPrev.addEventListener('click',()=>detailGo(detailActive-1));detailNext.addEventListener('click',()=>detailGo(detailActive+1));let detailTimer;detailTrack.addEventListener('scroll',()=>{clearTimeout(detailTimer);detailTimer=setTimeout(()=>{const step=detailCards[1].offsetLeft-detailCards[0].offsetLeft;detailMark(detailTrack.scrollLeft>=detailTrack.scrollWidth-detailTrack.clientWidth-3?detailCards.length-1:Math.round(detailTrack.scrollLeft/step))},120)});const form=root.querySelector('form');if(!form)return;form.querySelectorAll('select[name="id"]').forEach(select=>select.addEventListener('change',()=>{const input=select.options[select.selectedIndex];const button=form.querySelector('button[type="submit"]');form.querySelector('[data-cr-total]').textContent=input.dataset.crPrice;form.querySelector('[data-cr-count]').textContent=input.dataset.crCount;form.querySelector('.cr-offer-price [data-cr-unit]').textContent=input.dataset.crUnit;button.disabled=input.dataset.crAvailable!=='true';const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url)}))}document.querySelectorAll('.crates').forEach(initCrates);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.crates').forEach(initCrates));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
